import { Box, Divider, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Blogs } from "../utils/blogs";
import { useTranslation } from "react-i18next";
import { forwardRef } from "react";

const BlogsVivia = forwardRef((props, ref) => {
  const { t } = useTranslation();
  return (
    <Box ref={ref} sx={{ scrollMarginTop: "80px" }}>
      <Grid
        container
        sx={{
          justifyContent: "center",
          alignItems: "center",
          gap: 8,
          display: "flex",
          flexDirection: "column",
          borderWidth: "0px, 0px, 0px, 0px",

          borderStyle: "solid",
          cursor: "pointer",
          borderImageSource:
            "radial-gradient(50% 875.74% at 50% 50%, #33BBA4 0%, #1F8FCE 100%)",
          borderImageSlice: 1,
          // background:
          //   "radial-gradient(39.87% 39.87% at 50% 50%, #0C3247 0%, #081525 100%)",
          pt: 2,
          pb: 3,
        }}
      >
        <Grid>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: 700,
              fontSize: "18px",
              lineHeight: "60px",
              letterSpacing: "10%",
              textAlign: "center",
              verticalAlign: "middle",
              color: " #00387A",
            }}
          >
            {t("Our blog")}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: 900,
              fontSize: { xs: "30px", md: "39px" },
              lineHeight: { xs: "40px", lg: "60px" },
              letterSpacing: "10%",
              textAlign: "center",
              verticalAlign: "middle",
              color: " #00387A",
            }}
          >
            {t("Human & Impact-Focused")}
          </Typography>
        </Grid>

        <Grid
          display="flex"
          item
          xs={8}
          md={6}
          lg={10}
          xl={8.5}
          gap={6}
          alignItems="center"
          justifyItems="center"
          flexWrap={{ xs: "wrap", lg: "nowrap" }}
        >
          {Blogs.map((blog, index) => (
            <Paper
              onClick={() => window.open(blog.lien, "_blank")}
              sx={{
                boxShadow: "0px 0px 3px 0px #0000001A",
                pb: 2,
              }}
            >
              <Grid
                key={index}
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={4}
                pb={2}
                // size={{ md: 5, lg: 3.5 }}
              >
                {/* image */}
                <img
                  src={blog.image}
                  alt={`Blog${index}`}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    transition: "transform 0.3s ease",
                  }}
                />
                {/* date and category */}
                <Grid display="flex" justifyContent="center" gap={1}>
                  <Typography
                    sx={{
                      fontFamily: "Montserrat",
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "19px",
                      letterSpacing: "0%",
                      color: " #898989",
                    }}
                  >
                    {blog.date}
                  </Typography>
                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                      background: " #898989",
                    }}
                  />
                  <Typography
                    sx={{
                      fontFamily: "Montserrat",
                      fontWeight: 700,
                      fontSize: "14px",
                      lineHeight: "19px",
                      letterSpacing: "0%",
                      color: " #00387A",
                    }}
                  >
                    {blog.category}
                  </Typography>
                </Grid>
                {/* Title */}

                <Typography
                  sx={{
                    fontFamily: "IBM Plex Sans",
                    fontWeight: 700,
                    fontSize: { xs: "14px", lg: "14px" },
                    lineHeight: "18px",
                    letterSpacing: "0%",
                    textAlign: "justify",
                    verticalAlign: "middle",
                    width: { xs: "90%", lg: "90%", xl: "90%" },
                    // height: { xs: "65px", md: "50px" },
                  }}
                >
                  {blog.name}
                </Typography>
                {/* text */}
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontWeight: 400,
                    fontSize: "14px",
                    lineHeight: "22px",
                    letterSpacing: "-2%",

                    verticalAlign: "middle",
                    width: { xs: "90%", md: "80%" },
                    height: "120%",
                    mb: 1,
                    // color: "#3CB5A1",
                  }}
                >
                  {blog.text}
                </Typography>
              </Grid>
              {/* createdBy */}
              <Grid display="flex" justifyContent="flex-end" pr={2}>
                <Typography
                  sx={{
                    fontFamily: "Montserrat",
                    fontWeight: 700,
                    fontSize: "12px",
                    lineHeight: "13px",
                    letterSpacing: "1%",
                    verticalAlign: "middle",
                    color: "#737373",
                    borderBottom: "2px solid #C1C1C1",
                  }}
                >
                  {blog.createdBy}
                </Typography>
              </Grid>
            </Paper>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
});
export default BlogsVivia;
